import React from "react";
import { Card as CardType } from "../types";
import Card from "./Card";
import { cardStyles, getRingStyle } from "../styles";

interface TableauPileProps {
  cards: CardType[];
  isSelected?: boolean;
  isValidDestination?: boolean;
  onClick: () => void;
}

export const TableauPile: React.FC<TableauPileProps> = ({
  cards,
  isSelected = false,
  isValidDestination = false,
  onClick,
}) => {
  const ringStyle = getRingStyle(isSelected, isValidDestination);

  return (
    <div
      className={`${cardStyles.tableauContainer} ${ringStyle}`}
      onClick={onClick}
    >
      {cards.length === 0 ? (
        <div className="h-10 flex items-center justify-center"></div>
      ) : (
        <div className="flex flex-col items-center w-full">
          {cards.map((card, cardIndex) => (
            <Card key={`card-${cardIndex}`} card={card} compact={true} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TableauPile;
